import React from "react";
import images from 'react-payment-inputs/images';
import { PaymentInputsContainer, PaymentInputsWrapper } from 'react-payment-inputs';
import { startCardVerification, fetchVirtualCardRequestStatus, fetchVirtualCard, fetchSaveVirtualCard } from '../../api/virtual-card/actions'
import { removeTempCC } from '../../api/payers/actions'
import { removeInfoKey } from '../../api/information-collection/actions'
import { fetchCustomerMyPages } from "../../api/customers/actions";



const errorMessages = {
    'Enter a card number': 'Sláið inn kortanúmer',
    'Card number is invalid': 'Kortanúmerið er ógilt',
    'Enter an expiry date': 'Sláið inn gildistíma',
    'Expiry month must be between 01 and 12': 'Mánuður í gilditíma skal vera á milli 0-12',
    'Expiry year cannot be in the past': 'Ártal gildistíma má ekki vera liðið',
    'Expiry date cannot be in the past': 'Dagsetning gildistíma má ekki vera liðin',
    'Expiry date is invalid': 'Gildistími er ógildur',
    'Enter a CVC': 'Sláið inn öryggisnúmer',
    'CVC is invalid': 'Öryggisnúmer er ógilt',
}

class CardForm extends React.Component {
    constructor(props) {
        super(props)

        this.timer = null

        this.state = {
            cardObj: {
                cardNumber: '',
                expiryDate: '',
                cvc: '',
            },
            search: ""
        }

        this.handleChange = this.handleChange.bind(this)
        this.removeCard = this.removeCard.bind(this)
        this.startCardVerification = this.startCardVerification.bind(this)
    }

    getCardNumber() {
        return this.state.cardObj.cardNumber.replace(/\s/g, "")
    }

    getCardNumberMasked() {
        return `${this.getCardNumber().substr(0, 6)}******${this.getCardNumber().substr(this.getCardNumber().length - 4)}`
    }

    setInitialState() {
        this.setState({ cardObj: {
            cardNumber: '',
            expiryDate: '',
            cvc: '',
        }})
    }

    removeCard() {
        this.setState({
            ccNumberHasBeenSaved: false,
        })
        this.props.dispatch(removeTempCC(this.props.payerId))
    }

    getExpiryMonth() {
        let expDate = this.state.cardObj.expiryDate.split('/');
        let expYear = expDate[1].replace(/\s/g, "");
        let expMonth = expDate[0].replace(/\s/g, "");

    }


    handleChange(e) {
        this.setState({
            cardObj: { ...this.state.cardObj, [e.target.name]: e.target.value }
        })
    }

    cleanString(string){
        return string.replace(/\s/g, "")
    }

    validateInput(){
        let valid = false
        if (this.cleanString(this.state.cardObj.cardNumber).length === 16 && this.cleanString(this.state.cardObj.cvc).length === 3 && this.cleanString(this.state.cardObj.expiryDate).length === 5) {
            valid = true
        }
        return valid
    }

    startCardVerification() {
        if (this.validateInput()) {
            this.props.dispatch(startCardVerification(this.state.cardObj, this.props.payerId));
        }
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.virtualCard) !== JSON.stringify(this.props.virtualCard)) {
            if (!this.props.virtualCard.isFetching && this.props.virtualCard.results) {
                this.setInitialState();
            }

            if (this.props.virtualCard.status === 'requesting-verification' && prevProps.virtualCard.status !== 'requesting-verification') {
                this.timer = setInterval(() => this.props.dispatch(fetchVirtualCardRequestStatus(this.props.virtualCard.cardVerificationRequestToken, true)), 2000)
            }

            if (this.props.virtualCard.status === "cardnumber-verified" && prevProps.virtualCard.status !== "cardnumber-verified") {
                clearInterval(this.timer)
                this.props.dispatch(fetchVirtualCard(this.state.cardObj, this.props.payerId, this.props.virtualCard.cardVerificationRequestToken));
            }

            if (this.props.virtualCard.status === "virtualcard-received" && prevProps.virtualCard.status !== "virtualcard-received" && this.props.shouldAutoSave) {
                this.props.dispatch(fetchSaveVirtualCard({
                    cardNumber: this.getCardNumberMasked(),
                    virtualCard: this.props.virtualCard.results.virtualCard,
                    expirationMonth: this.props.payers.temporaryCC[this.props.payerId].expirationMonth,
                    expirationYear: this.props.payers.temporaryCC[this.props.payerId].expirationYear,
                }, this.props.payerId));
            }

            if (this.props.virtualCard.status === "virtualcard-saved" && prevProps.virtualCard.status !== "virtualcard-saved" && this.props.shouldAutoSave && this.props.inMyPages) {
                this.props.dispatch(fetchCustomerMyPages(this.props.payerId));
                this.setInitialState();
            }

            if (this.props.virtualCard.status === "verification-failed" && prevProps.virtualCard.status !== "verification-failed") {
                clearInterval(this.timer)
                this.setInitialState();
            }
            if (this.props.virtualCard.status === "virtualcard-save-error" && prevProps.virtualCard.status !== "virtualcard-save-error") {
                clearInterval(this.timer)
                this.setInitialState();
            }
        }
    }


    renderCardForm() {
        switch(this.props.virtualCard.status) {

            case 'start-requesting-verification':
            case 'cardnumber-verified':
                return (
                    <>Augnablik...</>
                )
            case 'virtualcard-received':

                    if (this.props.shouldAutoSave) {
                        return (
                            <>Augnablik...</>
                        )
                    } else {
                        return (
                            <div className="msg success-msg">Kort hefur verið vistað</div>
                        )
                    }
            case 'virtualcard-saved':
                return (
                    <div className="msg success-msg">Kort hefur verið vistað</div>
                )
                
            case 'requesting-verification':
                return <iframe src={`/api/v1/cardverification/${this.props.virtualCard.cardVerificationRequestToken}/`} />
                
            default:
                return (
                    <>
                        {this.props.virtualCard.status === 'verification-failed' &&
                            <div className="alert alert-danger">Villa kom upp við auðkenningu</div>
                        }
                        {this.props.virtualCard.status === 'virtualcard-save-error' &&
                            <div className="alert alert-danger">Ekki tókst að vista kort. Ástæða þess gæti verið rangur gildistími, rangt CVC númer, 3D Secure auðkenning hafi ekki tekist eða tímabundin bilun í greiðslukortakerfi. Vinsamlegast reynið aftur og hafið samband við skrifstofu Allianz ef vandamálið er viðvarandi.</div>
                        }
                        <PaymentInputsContainer>
                            {({ meta, getCardImageProps, getCardNumberProps, getExpiryDateProps, getCVCProps }) => (
                                <>
                                    {meta.error && meta.isTouched && <div className="msg error-msg xs-mb-20">{errorMessages[meta.error]}</div>}
                                    <div>
                                        <PaymentInputsWrapper>
                                            <svg {...getCardImageProps({ images })} />
                                            <input {...getCardNumberProps({ onChange: this.handleChange })} value={this.state.cardObj.cardNumber} name="cardNumber" placeholder="Kortanúmer" />
                                            <input {...getExpiryDateProps({ onChange: this.handleChange })} value={this.state.cardObj.expiryDate} name="expiryDate" />
                                            <input {...getCVCProps({ onChange: this.handleChange })} value={this.state.cardObj.cvc} name="cvc" />
                                        </PaymentInputsWrapper>
                                    </div>
                                </>
                            )}
                        </PaymentInputsContainer>
                        <div className="xs-mt-20">
                            <button type="button" className="btn btn-primary" onClick={this.startCardVerification}>{this.props.virtualCard.status === 'start-requesting-verification' ? 'Auðkenni kort...' : 'Auðkenna kort' }</button>
                        </div>
                    </>
                )
        }

    }


    render() {

        let errorMessage = ''
        try {
            errorMessage = errorMessages[meta.error]
        } catch (e) { }



        return (
            <div className={`xs-mb-20 ${this.props.className}`}>
                { this.renderCardForm() }
            </div>

        )
    }
}

CardForm.defaultProps = {
    shouldAutoSave: false,
    inMyPages: false,
    className: '',
}

export default CardForm